/*
 * File: app-routing.module.ts                                                 *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Tuesday, 28th February 2023 22:09:29                         *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatalogFormComponent } from './modules/catalog-cloud/components/catalog/catalog-form/catalog-form.component';
import { CatalogFormWizardComponent } from './modules/catalog-cloud/components/catalog/catalog-form-wizard/catalog-form-wizard.component';
import { CatalogHomeComponent } from './modules/catalog-cloud/components/catalog/catalog-home/catalog-home.component';
import { CatalogListComponent } from './modules/catalog-cloud/components/catalog/catalog-list/catalog-list.component';
import { FascicleEditComponent } from './modules/catalog-cloud/components/fascicle/fascicle-edit/fascicle-edit.component';
import { FascicleListAloneComponent } from './modules/catalog-cloud/components/fascicle/fascicle-list-alone/fascicle-list-alone.component';
import { PageTemplateFormComponent } from './modules/catalog-cloud/components/page/page-template-form/page-template-form.component';
import { PageTemplateListComponent } from './modules/catalog-cloud/components/page/page-template-list/page-template-list.component';
// import { ListComponent } from './modules/user/components/list/list.component';
// import { LoginComponent } from './modules/user/components/login/login.component';
import { CatalogResolver } from './modules/catalog-cloud/resolvers/catalog.resolver';
import { FascicleResolver } from './modules/catalog-cloud/resolvers/fascicle.resolver';
import { BackupsListComponent } from './modules/backups/components/backups-list/backups-list.component';
import { NotFoundComponent } from './modules/tms-tools/components/not-found/not-found.component';
import { LoginActivate } from './modules/user/helpers/login-activate.helper';
import { AuthComponent } from './modules/user/components/auth/auth.component';
import { UserLoginComponent } from './modules/user/components/user-login/user-login.component';
import { FascicleEditResolver } from './modules/catalog-cloud/resolvers/fascicle-edit.resolver';
import { PageTemplateResolver } from './modules/catalog-cloud/resolvers/page-template.resolver';
import { CatalogNewResolver } from './modules/catalog-cloud/resolvers/catalog-new.resolver';
import { CatalogEditResolver } from './modules/catalog-cloud/resolvers/catalog-edit.resolver';
import { CatalogFormEditComponent } from './modules/catalog-cloud/components/catalog/catalog-form-edit/catalog-form-edit.component';
import { FascicleNewResolver } from './modules/catalog-cloud/resolvers/fascicle-new.resolver';
import { FascicleFormEditResolver } from './modules/catalog-cloud/resolvers/fascicle-form-edit.resolver';
import { FascicleFormComponent } from './modules/catalog-cloud/components/fascicle/fascicle-form/fascicle-form.component';
import { FascicleAutoFormComponent } from './modules/catalog-cloud/components/fascicle/fascicle-auto-form/fascicle-auto-form.component';
import { PageTemplateNewResolver } from './modules/catalog-cloud/resolvers/page-template-new.resolver';
import { PageTemplateEditResolver } from './modules/catalog-cloud/resolvers/page-template-edit.resolver';
import { apiServerGuard } from './modules/catalog-cloud/guards/api-server.guard';
import { CatalogIndexComponent } from './modules/catalog-cloud/components/catalog/catalog-index/catalog-index.component';
import { CatalogIndexResolver } from './modules/catalog-cloud/resolvers/catalog-index.resolver';

const routes: Routes = [
  {
    path: '',
    resolve: {
      breadcrumbs: CatalogResolver
    },
    component: CatalogHomeComponent,
    canActivate: [apiServerGuard, LoginActivate],
  },
  {
    path: 'dash',
    component: CatalogHomeComponent,
    resolve: {
      breadcrumbs: CatalogResolver
    },
    canActivate: [apiServerGuard, LoginActivate],
  },
  {
    path: "auth",
    component: AuthComponent,
    title: "Syncwall - Auth",
    canActivate: [apiServerGuard]
  },
  {
    path: "auth/:id/:userId",
    component: AuthComponent,
    title: "Syncwall - Auth"

  },
  {
    path: 'catalog',
    canActivate: [apiServerGuard, LoginActivate],

    children: [
      {
        path: 'list',
        resolve: {
          breadcrumbs: CatalogResolver
        },
        component: CatalogListComponent,
        canActivate: [apiServerGuard, LoginActivate],
      },
      {
        path: 'new',
        component: CatalogFormWizardComponent,
        canActivate: [LoginActivate],
        resolve: {
          breadcrumbs: CatalogNewResolver
        },
      },
      {
        path: ':id/edit',
        component: CatalogFormEditComponent,
        canActivate: [apiServerGuard, LoginActivate],
        resolve: {
          breadcrumbs: CatalogEditResolver,
        },
      },
      {
        path: ':id',
        component: CatalogFormComponent,
        canActivate: [apiServerGuard, LoginActivate],
      }
    ],
  },

  {
    path: 'catalog/:idCatalog/fascicles',
    canActivate: [apiServerGuard, LoginActivate],
    resolve: {
      breadcrumbs: FascicleResolver,
    },
    component: FascicleListAloneComponent,
  },
  {
    path: 'catalog/:idCatalog/index',
    canActivate: [apiServerGuard, LoginActivate],
    resolve: {
      breadcrumbs: CatalogIndexResolver,
    },
    component: CatalogIndexComponent,
  },
  {
    path: 'catalog/:idCatalog/fascicles/new',
    canActivate: [apiServerGuard, LoginActivate],
    resolve: {
      breadcrumbs: FascicleNewResolver,
    },
    component: FascicleFormComponent,
  },
  {
    path: 'catalog/:idCatalog/fascicles/new-auto',
    canActivate: [apiServerGuard, LoginActivate],
    resolve: {
      breadcrumbs: FascicleNewResolver,
    },
    component: FascicleAutoFormComponent,
  },
  {
    path: 'catalog/:idCatalog/fascicles/:id/edit',
    canActivate: [apiServerGuard, LoginActivate],
    resolve: {
      breadcrumbs: FascicleFormEditResolver,
    },
    component: FascicleFormComponent,
  },
  {
    path: 'page-templates',
    canActivate: [apiServerGuard, LoginActivate],
    data: {
      breadcrumb: 'PAGE.TEMPLATE_LIST',
    },
    children: [
      {
        path: 'list',
        component: PageTemplateListComponent,
        resolve: {
          breadcrumbs: PageTemplateResolver,
        },
        canActivate: [apiServerGuard, LoginActivate],
      },
      {
        path: 'new',
        component: PageTemplateFormComponent,
        canActivate: [apiServerGuard, LoginActivate],
        resolve: {
          breadcrumbs: PageTemplateNewResolver,
        },
      },
      {
        path: ':id',
        component: PageTemplateFormComponent,
        canActivate: [apiServerGuard, LoginActivate],
        resolve: {
          breadcrumbs: PageTemplateEditResolver,
        },
      },
    ],
  },
  {
    path: 'catalog/:idCatalog/fascicle/:id',
    resolve: {
      breadcrumbs: FascicleEditResolver,
    },
    component: FascicleEditComponent,
    canActivate: [apiServerGuard, LoginActivate],
  },
  {
    path: 'login',
    component: UserLoginComponent,

  },
  {
    path: 'backups',
    canActivate: [apiServerGuard, LoginActivate],
    data: {
      breadcrumb: 'Listado de backups',
    },
    component: BackupsListComponent,

  },
  {
    path: 'design-system',
    loadChildren: () =>
      import('./modules/design-system/design-system.module').then(
        (m) => m.DesignSystemModule
      ),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
